import script from "./AlbumCreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumCreateModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumCreateModal.vue?vue&type=style&index=0&id=3b54f12d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b54f12d"]])

export default __exports__